
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { ICentroCusto } from "../../../types/api/geral/pesquisar-plano-contas";

export default function DialogCentroCusto({
    open,
    opcoes,
    handleClose,
    handleSubmit
}: DialogCentroCustoProps) {

    const [inputValue, setInputValue] = useState<string>('');
    const [selected, setSelected] = useState<ICentroCusto | null>(null)

    //funções manipuladoras
    const handleConfirm = () => {
        if(selected) handleSubmit(selected)
    }
    //

    //valores importantes
    const valoresPossiveis = opcoes || []
    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="body"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                Selecionar centro de custo
            </DialogTitle>

            <DialogContent>
                <Box my={1}>
                    <Autocomplete
                        options={valoresPossiveis}
                        onChange={(_: any, newValue: ICentroCusto | null) => {
                            setSelected(newValue);
                        }}
                        inputValue={inputValue}
                        onInputChange={(_, newInputValue) => {
                            setInputValue(newInputValue);
                        }}
                        id="controllable-states-demo"
                        fullWidth
                        getOptionLabel={(option) => (`${option.id} - ${option.nome}`)}
                        renderInput={(params) => <TextField {...params} label="Centro custo" />}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    disabled={!selected}
                    variant="contained"
                    onClick={handleConfirm}
                >
                    Selecionar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogCentroCustoProps {
    open: boolean,
    opcoes: ICentroCusto[] | null,
    handleClose: () => void,
    handleSubmit: (arg: ICentroCusto) => void
}
